// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__table--C1v9G .ant-table-cell-with-append {
  white-space: nowrap;
  overflow: hidden;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__table--C1v9G .ant-table-cell-with-append a {
  color: black;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__table--C1v9G .ant-table-cell-with-append a:hover {
  text-decoration: underline;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__th--nHsaJ {
  padding: 0 !important;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__headCell--pxYFL {
  display: flex;
  height: 100%;
  padding: 8px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__headLabel--PtPEW {
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsPlanning2/Planning2Control/Planning2Table/Planning2Table.module.less"],"names":[],"mappings":"AAAA;EAEI,mBAAA;EACA,gBAAA;AAAJ;AAHA;EAKM,YAAA;AACN;AANA;EAQM,0BAAA;AACN;AAGA;EACE,qBAAA;AADF;AAGA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AADF;AAIA;EACE,OAAA;EAEA,uBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAJF","sourcesContent":[".table {\n  :global(.ant-table-cell-with-append) {\n    white-space: nowrap;\n    overflow: hidden;\n    a {\n      color: black;\n    }\n    a:hover {\n      text-decoration: underline;\n    }\n  }\n}\n.th {\n  padding: 0 !important;\n}\n.headCell {\n  display: flex;\n  height: 100%;\n  padding: 8px;\n}\n\n.headLabel {\n  flex: 1;\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 160%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__table--C1v9G`,
	"th": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__th--nHsaJ`,
	"headCell": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__headCell--pxYFL`,
	"headLabel": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Table-Planning2Table-module__headLabel--PtPEW`
};
export default ___CSS_LOADER_EXPORT___;
